export enum ReferenceTypeEnum {
    ScienceArticle = "SCIENCE_ARTICLE",
    Patent = "PATENT",
    InternalLink = "INTERNAL_LINK",
    Technology = "TECHNOLOGY",
    Image = "IMAGE",
    YoutubeVideo = "YOUTUBE_VIDEO"
}